import { getSessionItem } from "@/utils/storage";

export function getTenantId() {
  return getSessionItem('tenantId') || getSessionItem('tenant_codigo') || '';
}

export function getToken() {
  return getSessionItem('token');
}

export async function apiFetch(url: string, options: RequestInit = {}) {
  const backend_api = import.meta.env.VITE_API_URL_BACKEND;
  const token = getToken();
  const tenantId = getTenantId();

  const headers: any = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(tenantId ? { 'x-tenant-id': tenantId } : {}),
  };

  if (!(options.body instanceof FormData) && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  return fetch(`${backend_api}/${url}`, { ...options, headers });
}